export const DIRECTORY_SERVICES = {
    azure: "Azure",
    apache: "Apache"
}
export const AZURE_DIRECTORY_FORM = {
    heading: "Azure Active Directory",
    description: "Enter your Azure Active Directory credentials to enable SSO for your organization.",
    tenantId: "Tenant ID",
    consentUrl: "Consent URL",
    save: "SAVE",
    errorMsgs: {
        emptyTenantId: "Please enter tenant id"
    },
    successMsg: "Azure Active Directory Credientials added successfully",
    consent: "Grant Access",
    activate_access: "Activate Access",
    deactivate_access: "Revoke Access",

}
export const APACHE_DIRECTORY_FORM = {
    heading: "Apache Active Directory",
    description: "Enter your Apache Active Directory credentials to enable SSO for your organization.",
    serverUrl: "Server URL",
    adminDn: "Admin DN",
    adminPassword: "Admin Password",
    save: "SAVE",
    errorMsgs: {
        emptyServerUrl: "Please enter server URL",
        emptyAdminDn: "Please enter Admin DN",
        emptyAdminPassword: "Please enter Admin password"
    },
    successMsg: "Apache Active Directory Credientials added successfully"
}
export const SHAREPOINT_HOST_INPUT_LABEL = "Enter host e.g contoso.sharepoint.com"
export const SOMETHING_WENT_WRONG = "Something went wrong. Please try again."
export const DIRECTORY_SERVICE = "Directory Services"
export const SELECT_DIRECTORY_SERVICE = "Select Directory Service"
export const ADD_DIRECTORY_SERVICE = "Add Directory Service"
export const DIRECTORY_SERVICES_LIST = ['azure']
export const SIGN_IN_WITH_ENTRA_ID = "Sign in with Entra ID"
export const FILE_UPLOADED =  'File uploaded successfully!'
export const SAML_FILE_TYPE_ERROR = 'The selected file is not an XML file. Please upload a valid XML file.'
export const SAML_NO_FILE = 'Please select an XML file to upload.'
export const INVALID_CONSENT_TOKEN = 'Token is either invalid or expired. Please try again.'
export const AZURE_OAUTH_OPTIONS = [
    { value: 'oidc', label: 'OpenId Connect' },
    { value: 'saml', label: 'SAML' },
];
export const CONNECTOR_TYPES = {
    OIDC: 'oidc',
    SAML: 'saml'
}
export const COPIED_TIMEOUT = 5000